import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {MenuVisitaVinculacion} from '../_models/menu-visita-vinculacion';

@Injectable({
  providedIn: 'root'
})
export class MenuVisitaVinculacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/menuVisitaVinculaciones/';

  constructor(private httpClient: HttpClient, private autServicio: AutenticacionService) {
  }

  listado() {
    return this.httpClient.get(this.rutServicio).pipe(map(res => res as MenuVisitaVinculacion[]));
  }

  listadoHabilitados() {
    return this.httpClient.get(this.rutServicio + 'enabled').pipe(map(res => res as MenuVisitaVinculacion[]));
  }

  listadoPorVinculacion( id: string) {
    return this.httpClient.get(this.rutServicio + 'tipoVinculacion/' + id).pipe(map(res => res as MenuVisitaVinculacion[]));
  }
  listadoPorVinculacionSoloPadres( id: string) {
    return this.httpClient.get(this.rutServicio + 'tipoVinculacion/' + id+'/onlyParents').pipe(map(res => res as MenuVisitaVinculacion[]));
  }

  obtenerPorId(id: string) {
    return this.httpClient.get(this.rutServicio + id).pipe(map(res => res as MenuVisitaVinculacion));
  }

  crear(regCrear: MenuVisitaVinculacion) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post(this.rutServicio, regCrear).pipe(map(res => res as MenuVisitaVinculacion));
  }

  crearConHijos(regCrear: MenuVisitaVinculacion) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post(this.rutServicio+'bulkBranch/', regCrear).pipe(map(res => res as MenuVisitaVinculacion));
  }

  actualizar(regActualizar: MenuVisitaVinculacion) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put(this.rutServicio, regActualizar).pipe(map(res => res as any));
  }

}
